import type { IconProps } from '../types/IconProps.ts';
export const Receipt: IconProps = {
    name: 'Receipt',
    children: [
        `<path d="M12 8v10M14 9h-3.33C9.75 9 9 9.9 9 11s.75 2 1.67 2h2.42" />`,
        `<path d="M11.36 13h1.97c.92 0 1.67.9 1.67 2s-.75 2-1.67 2H10" />`,
        `<path d="M4 2.72a.5.5 0 0 1 .68-.47l1.77.67q.22.08.42-.03l1.33-.75a.5.5 0 0 1 .49 0l1.29.72a.5.5 0 0 0 .49 0l1.28-.72a.5.5 0 0 1 .5 0l1.28.72a.5.5 0 0 0 .5 0l1.28-.72a.5.5 0 0 1 .5 0l1.32.75a.5.5 0 0 0 .42.03l1.77-.67a.5.5 0 0 1 .68.47V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />`,
    ]
};